import { CSSProperties, ReactNode } from "react";
import { Icon } from "../../elements/Icon";
import { checkCircleFilled2 } from "../../elements/Icon/Icon.types";
import { styles } from "./VinSummaryCard.style";

const DEFAULT_ANIMATION_SRC = "/animations/car-animation.html";

export interface VinSummaryCardProps {
  vin: string;
  statsHeading: string;
  stats: ReactNode[];
  illustrationAlt?: string;
  animationSrc?: string;
  vinLabel: string;
}

export const VinSummaryCard = ({
  vin,
  statsHeading,
  stats,
  illustrationAlt = "",
  vinLabel,
  animationSrc = DEFAULT_ANIMATION_SRC,
}: VinSummaryCardProps) => {
  return (
    <div className={styles.card()}>
      <div className={styles.illustrationArea()}>
        <iframe
          className={styles.illustrationImage()}
          src={animationSrc}
          title={illustrationAlt}
          aria-label={illustrationAlt}
          loading="lazy"
          tabIndex={-1}
        />
      </div>

      <div className={styles.vinPill()}>
        <span className={styles.vinText()}>
          {vinLabel}: {vin}
        </span>
      </div>

      <div className={styles.statsSection()}>
        <p className={styles.statsHeading()}>{statsHeading}</p>
        <ul className={styles.statsList()}>
          {stats.map((stat, index) => (
            <li
              key={index}
              className={styles.statItem()}
              style={
                {
                  "--stat-index": index,
                  "--stat-count": stats.length,
                } as CSSProperties
              }
            >
              <span className={styles.statIcon()}>
                <Icon icon={checkCircleFilled2} size={24} role="presentation" />
              </span>
              <span className={styles.statText()}>{stat}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
